import React, { Component } from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazyload';
import TimeAgo from 'react-timeago';
import Clipboard from 'clipboard';
import { Tooltip } from 'react-tippy';

class Track extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSet: false,
      copied: false
    };
  }
  componentWillMount() {
    const trackLink = this.props.link;

    this.setState({
      isSet: trackLink.match(/\/sets\//)
    });
  }
  componentDidMount() {
    const clipboard = new Clipboard('.track-permalink');
  }
  copyLink(e) {
    e.stopPropagation();

    this.setState({
      copied: true
    });

    setTimeout(() => {
      this.setState({
        copied: false
      });
    }, 3000);
  }
  render() {
    return (
      <TrackItem
        className={this.props.playing ? 'playing' : null}
        data-track-state={this.props.played}
        data-number={this.props.number}
      >
        {/* <LazyLoad
          height={162}
          offset={0}
          overflow
          placeholder={<PlaceholderComponent />}
        > */}
        <Thumbnail src={this.props.image} />
        {/* </LazyLoad> */}
        <Info>
          <TrackNumber>{this.props.number + 1}</TrackNumber>
          {this.state.isSet && <SetLabel>SET</SetLabel>}
          {this.props.playing &&
            this.props.activelyPlaying && (
              <Icon className="iconPlaying">{playingIcon}</Icon>
            )}
          {this.props.featured && (
            <Star className={this.props.playing ? 'playing' : null}>
              {iconStar}
            </Star>
          )}

          <TelegramButton
            className="kudos-telegram"
            target="_blank"
            onClick={e => e.stopPropagation()}
            href={`https://t.me/share/url?url=Thanks for sharing this one, @${this.props.user}! https://classic.line.fm/?play=${this.props.id}`}
          >
            <Tooltip
              title={`Thank @${this.props.user} on Telegram for sharing this track.`}
              position="bottom"
              trigger="mouseenter"
              arrow={false}
              inertia
              size="small"
            >
              {telegramIcon}
            </Tooltip>
          </TelegramButton>

          <SpotifyButton
            className="search-on-spotify"
            onClick={e => e.stopPropagation()}
            href={`spotify:search:${this.props.title
              .replace('(Official Video)', '')
              .replace('(Original Mix)', '')
              .replace('(Official)', '')
              .replace('(OFFICIAL)', '')
              .replace('[Official Music Video]', '')
              .replace('ft.', '')
              .replace('feat.', '')
              .replace('Feat.', '')
              .replace('--', '')
              .replace(' & ', ' ')
              .replace(' x ', ' ')}`}
          >
            <Tooltip
              title="Search for this track on Spotify"
              position="bottom"
              trigger="mouseenter"
              arrow={false}
              inertia
              size="small"
            >
              {spotifyIcon}
            </Tooltip>
          </SpotifyButton>

          <ClipboardButton
            className="track-permalink"
            target="_blank"
            data-clipboard-text={`https://classic.line.fm/?play=${this.props.id}`}
            onClick={this.copyLink.bind(this)}
          >
            <Tooltip
              title="Copy link"
              position="bottom"
              trigger="mouseenter"
              arrow={false}
              inertia
              size="small"
            >
              {this.state.copied ? doneIcon : clipboardIcon}
            </Tooltip>
          </ClipboardButton>
          <Title>{this.props.title}</Title>
          <Meta>
            <Author>
              Added{' '}
              {this.props.user && (
                <span>
                  by{' '}
                  <a
                    href={`http://t.me/${this.props.user}`}
                    target="_blank"
                    onClick={e => {
                      e.stopPropagation();
                    }}
                  >
                    @{this.props.user}
                  </a>
                </span>
              )}{' '}
              <TimeAgo date={this.props.date} />
            </Author>
            <Source
              href={this.props.link}
              target="_blank"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <img src={this.props.logo} width="18px" />
            </Source>
          </Meta>
        </Info>
      </TrackItem>
    );
  }
}

export default Track;

const TrackItem = styled.div`
  display: block;
  line-height: 1.5;
  position: relative;
  height: 9rem;
  min-height: 164px;
  @media (max-width: 760px) {
    ${'' /* height: 7.5rem; */};
  }
  border-radius: 8px;
  overflow: hidden;
  user-select: none;
  box-shadow: 0 0 0 0 transparent, inset 0 0 0 1px rgba(255, 255, 255, 0.1),
    0 3px 15px 0 rgba(0, 0, 0, 0.5);
  transition: 0.08s ease opacity;

  img {
    transition: 0.08s ease opacity, 2.25s ease transform;
  }

  &:hover {
    box-shadow: 0 0 0 4px #27ae60, inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    img {
      opacity: 1 !important;
      transform: scale(1.05);
    }
  }

  &.playing {
    box-shadow: 0 0 0 4px #27ae60, inset 0 0 0 1px rgba(255, 255, 255, 0.1);
  }

  &[data-track-state='played']:not(:hover) {
    img {
      opacity: 0.15;
    }
    h2 {
      opacity: 0.5;
    }
  }

  &:active {
    transform: scale(0.98);
  }

  .lazyload-placeholder {
    position: absolute !important;
  }

  &:hover {
    .iconPlaying {
      opacity: 0;
      visibility: hidden;
    }

    .track-permalink,
    .search-on-spotify,
    .kudos-telegram {
      opacity: 1;
      visibility: visible;
    }
  }
`;

const TrackNumber = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  padding: 0.25em 0.75em;
  font-size: 0.75rem;
  border-radius: 7px 0 6px 0;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
  @supports (-webkit-backdrop-filter: blur(0)) {
    background-color: black(0.25);
    -webkit-backdrop-filter: blur(12px) saturate(150%) contrast(120%);
    box-shadow: none;
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0;
  z-index: -1;
  opacity: 0.85;
  object-fit: cover;
  border-radius: 7px;
  transition: 0.15s ease opacity;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  padding: 0.5rem;
  background-image: linear-gradient(0deg, #121212 5%, rgba(0, 0, 0, 0) 100%);
`;

const Title = styled.h2`
  font-size: 1rem;
  line-height: 1.35;
  margin: 0;
`;

const Meta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  letter-spacing: -0.025em;
  margin-top: 0.25rem;
`;

const Author = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.35);
  flex-shrink: 0;

  span,
  time {
    color: rgba(255, 255, 255, 0.35);
  }

  a {
    text-decoration: none;
    color: rgba(255, 255, 255, 0.75);
  }
`;

const Source = styled.a`
  line-height: 0;
  transition: 0.15s ease all;
  z-index: 2;

  img {
    border-radius: 5px;
  }

  &:hover {
    transform: scale(1.5);
  }
`;

const SetLabel = styled.span`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: calc(0.55rem - 1px);
  right: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  height: 1.125rem;
  padding: 0 0.35rem;
  padding-right: 1.25rem;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.25;
  border-radius: 6px;
  color: #000;
  background: linear-gradient(180deg, #fe7e00, #f83600);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  z-index: 1;
`;

const Icon = styled.span`
  position: absolute;
  top: 0.25rem;
  right: 0.5rem;
  transition: 0.15s ease all;
`;

const playingIcon = (
  <svg
    width="11"
    height="16"
    viewBox="0 0 55 80"
    xmlns="http://www.w3.org/2000/svg"
    fill="#FFF"
  >
    <g transform="matrix(1 0 0 -1 0 80)">
      <rect width="10" height="20" rx="3">
        <animate
          attributeName="height"
          begin="0s"
          dur="4.3s"
          values="20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="15" width="10" height="80" rx="3">
        <animate
          attributeName="height"
          begin="0s"
          dur="2s"
          values="80;55;33;5;75;23;73;33;12;14;60;80"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="30" width="10" height="50" rx="3">
        <animate
          attributeName="height"
          begin="0s"
          dur="1.4s"
          values="50;34;78;23;56;23;34;76;80;54;21;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="45" width="10" height="30" rx="3">
        <animate
          attributeName="height"
          begin="0s"
          dur="2s"
          values="30;45;13;80;56;72;45;76;34;23;67;30"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </rect>
    </g>
  </svg>
);

class PlaceholderComponent extends Component {
  render() {
    return (
      <PlaceholderContainer>
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#fff"
        >
          <g fill="none" fillRule="evenodd" strokeWidth="2">
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="0s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="0s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="-0.9s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="-0.9s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </PlaceholderContainer>
    );
  }
}

const PlaceholderContainer = styled.div`
  width: 100%;
  height: 8rem;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Star = styled.div`
  padding: 0.25rem 1.25rem 1rem 0.25rem;
  font-size: 0.75rem;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  border-radius: 8px 0 0 0;
  pointer-events: none;
  clip-path: polygon(0 0, 0% 100%, 100% 0);
  background-color: #fbc02d;
  transition: 0.15s ease all;

  svg path {
    transition: 0.15s ease all;
  }

  &.playing {
    background-color: #27ae60;

    svg path {
      fill: #fff;
    }
  }
`;

const iconStar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="#c75d00"
      d="M15.144 5.438l-4.316-.627L8.897.9C8.559.217 7.441.217 7.103.9l-1.93 3.911-4.317.627a1.002 1.002 0 0 0-.554 1.707l3.124 3.044-.737 4.299a1 1 0 0 0 1.451 1.054L8 13.513l3.861 2.03c.728.381 1.591-.234 1.451-1.054l-.737-4.299 3.124-3.044a1.003 1.003 0 0 0-.555-1.708z"
    />
  </svg>
);

const ClipboardButton = styled.button`
  outline: 0;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  margin-right: 0.5rem;
  transition: 0.15s ease all;
  flex-shrink: 0;
  position: absolute;
  top: 0.25rem;
  right: -0.25rem;
  opacity: 0;
  visibility: hidden;

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }

  &:active {
    transform: scale(0.92);
    background-color: #00a8ff;
  }

  > div {
    line-height: 0;
  }
`;

const SpotifyButton = styled.a`
  outline: 0;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  margin-right: 0.5rem;
  transition: 0.15s ease all;
  flex-shrink: 0;
  position: absolute;
  top: 0.25rem;
  right: 2rem;
  opacity: 0;
  visibility: hidden;

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }

  &:active {
    transform: scale(0.92);
    background-color: HSLA(141, 76%, 48%, 1);
  }

  > div {
    line-height: 0;
  }
`;

const TelegramButton = styled.a`
  outline: 0;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  margin-right: 0.5rem;
  transition: 0.15s ease all;
  flex-shrink: 0;
  position: absolute;
  top: 0.25rem;
  right: 4rem;
  opacity: 0;
  visibility: hidden;

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }

  &:active {
    transform: scale(0.92);
    background-color: HSLA(141, 76%, 48%, 1);
  }

  > div {
    line-height: 0;
  }
`;

const clipboardIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <g fill="#fff">
      <path d="M4.5 16c-1.2 0-2.3-.5-3.2-1.3-1.8-1.8-1.8-4.6 0-6.4l.7-.7L3.4 9l-.7.7c-1 1-1 2.6 0 3.6s2.6 1 3.6 0l3-3c1-1 1-2.6 0-3.6L8.6 6 10 4.6l.7.7c1.8 1.8 1.8 4.6 0 6.4l-3 3c-.8.8-2 1.3-3.2 1.3z" />
      <path d="M6 11.4l-.7-.7c-1.8-1.8-1.8-4.6 0-6.4l3-3c.9-.9 2-1.3 3.2-1.3s2.3.5 3.2 1.3c1.8 1.8 1.8 4.6 0 6.4l-.7.7L12.6 7l.7-.7c1-1 1-2.6 0-3.6s-2.6-1-3.6 0l-3 3c-1 1-1 2.6 0 3.6l.7.7L6 11.4z" />
    </g>
  </svg>
);

const doneIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="#fff"
      d="M14.3 2.3L5 11.6 1.7 8.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l4 4c.2.2.4.3.7.3s.5-.1.7-.3l10-10c.4-.4.4-1 0-1.4s-1-.4-1.4 0z"
    />
  </svg>
);

const spotifyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
  >
    <g>
      <path
        fill="#fff"
        d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M11.7,11.6c-0.2,0.2-0.4,0.3-0.7,0.2
c-1.9-1.2-4.2-1.4-7-0.8c-0.3,0.1-0.5-0.1-0.6-0.4c-0.1-0.3,0.1-0.5,0.4-0.6c3-0.7,5.7-0.4,7.8,0.9C11.8,11,11.8,11.3,11.7,11.6z
 M12.6,9.4c-0.2,0.3-0.6,0.4-0.8,0.2c-2.2-1.3-5.4-1.7-8-0.9C3.5,8.7,3.2,8.6,3.1,8.2C3,7.9,3.2,7.6,3.5,7.5c2.9-0.9,6.5-0.4,9,1.1
C12.7,8.7,12.8,9.1,12.6,9.4z M12.7,7.1c-2.6-1.5-6.8-1.7-9.3-0.9C3,6.3,2.6,6.1,2.5,5.7C2.4,5.3,2.6,4.9,3,4.8
C5.8,4,10.5,4.1,13.5,5.9c0.4,0.2,0.5,0.7,0.3,1C13.6,7.2,13.1,7.3,12.7,7.1z"
      />
    </g>
  </svg>
);

const telegramIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" width="18" height="18"><path fill="#fff" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"/></svg>
);


// WEBPACK FOOTER //
// ./src/components/Track/Track.js